import { connect } from 'react-redux';
import { IState } from '../../../reducers';

import { Breadcrumb } from './breadcrumb';

const mapStateToProps = (state: IState) => ({
    breadcrumbItem: state.breadcrumb
});

const mapDispatchToProps = (dispatch: any) => ({
});

export const BreadcrumbContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Breadcrumb);


// WEBPACK FOOTER //
// ./src/common/components/breadcrumb/breadcrumbContainer.tsx